import React from "react";
import "./Dental_Implant.css";
import Teeth_Whiting_img from "../images/overdenture-3597628_1920.jpg";
function DENTAL_IMPLANT() {
  return (
    <div className="container_Dental">
      <h1>DENTAL IMPLANT</h1>
      <div className="img_box_Dental">
        <img src={Teeth_Whiting_img} className="img_of_Dental" alt="" />
      </div>
      <div className="text_main_Dental">
        <p>
          Dental implants are surgical components helps maintain tooth
          prosthetics that are fabricated to forever durability. These fake
          roots are moored in the bone underneath the gums where they merge into
          the jaw. A crown is mounted for an enduring and normal looking grin.
          Numerous dental specialists and patients are inclined towards dental
          implants since they offer equivalent capacity as of the regular teeth
          and furthermore help anticipate bone disintegration in the jaw. Dental
          implants replaces a solitary absent or harmed tooth or to re-establish
          a perfect smile.{" "}
        </p>
        <h1>DID YOU KNOW??</h1>
        <p>
          That roughly 30 million dental patients are opting for dental implants
          as a methods for tooth substitution. The American Academy of Implant
          Dentistry reports that 3 million individuals presently have dental
          inserts – a number that is quickly developing by around 500,000 every
          year. Present day titanium inserts were first created in the 1950's,
          however archaeologists have confirmed that old Egyptians and Mayans
          were the principal societies to embed counterfeit teeth.
        </p>
        <div className="FAQ_Service_Dental">
          <h2>FAQ'S</h2>
        </div>
      </div>
    </div>
  );
}
export default DENTAL_IMPLANT;
